import { render, staticRenderFns } from "./TopRemak.vue?vue&type=template&id=aa112dea&scoped=true"
import script from "./TopRemak.vue?vue&type=script&lang=js"
export * from "./TopRemak.vue?vue&type=script&lang=js"
import style0 from "./TopRemak.vue?vue&type=style&index=0&id=aa112dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa112dea",
  null
  
)

export default component.exports